export type Compute<T> = { [K in keyof T]: Compute<T[K]> } | never;

export type ValueOf<Obj> = Obj[keyof Obj];

type DeepReadonlyObject<T> = {
  readonly [P in keyof T]: DeepReadonly<T[P]>;
};

type DeepReadonlyArray<T> = DeepReadonly<T>[];

export type DeepReadonly<T> = T extends (infer R)[]
  ? DeepReadonlyArray<R>
  : T extends (...args: never[]) => unknown
    ? T
    : T extends object
      ? DeepReadonlyObject<T>
      : T;

/**
 * type-guard function to check at run-time if a value is a string
 * @param value
 * @returns - boolean, true if the value is a string
 */
export function isString(value: unknown): value is string {
  return typeof value === "string";
}

/**
 * type-guard function to check at run-time if all the elements inside
 * from the array are strings
 * @param array
 * @returns - boolean, true if the array is string array
 */
export function isStringArray(array: unknown[]): array is string[] {
  return array.every((element) => typeof element === "string");
}

/**
 * type-guard function to check at run-time if all the elements inside
 * from the array are numbers
 * @param array
 * @returns - boolean, true if the array is number array
 */
export function isNumberArray(array: unknown[]): array is number[] {
  return array.every((element) => typeof element === "number");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Constructable<T = any> = { new (...args: any[]): T };

export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export type PartialWithDuid<T> = Partial<T> & { duid: string };

export type Awaitable<T> = T | Promise<T>;
